import React, {useEffect } from 'react'; 
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
import HomeSlider from "../Component/HomeSlider";
import HomeNews from "../Component/HomeNews";
import HomeMessage from "../Component/HomeMessage"; 
import HomeTopperXII from "../Component/HomeTopperXII";
import HomeTopperX from "../Component/HomeTopperX";
import HomeGallery from "../Component/HomeGallery";
import HomeBirthday from "../Component/HomeBirthday";
import { Link } from "react-router-dom";
import ParentPortal from "../Component/ParentPortal";
import ModalPopup from "../Component/ModalPopup";
import LazyLoad from "react-lazyload";
const Home = () => {
  useEffect(() => {
    document.title = 'Home -  Sacred Heart School, Ballia - U.P.';  
}, []); 
  return (
    <>
    <Header/>
      <ModalPopup />

      <ParentPortal />
      <HomeSlider />

      <div className="midsec">
        <div className="midsecbox1">
          <Link to="https://shsb.campussoft.net/" target="_blank" className="midsecboxsec">
            <div className="midsecboxsecimg">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Disclosureimg.png"
                  className="img-fluid"
                  alt="Sacred Heart School Balia"
                />
              </LazyLoad>
            </div>
            <div className="midsecboxsecdesc">
              <p>Teacher Login</p>
            </div>
          </Link>
          <Link to="https://shsb.campussoft.net/" target="_blank"  className="midsecboxsec yel" rel="noreferrer">
            <div className="midsecboxsecimg">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/teacher-login.png"
                  className="img-fluid"
                  alt="Sacred Heart School Balia"
                />
              </LazyLoad>
            </div>
            <div className="midsecboxsecdesc">
              <p>Principal Login</p>
            </div>
          </Link>
          <Link to="/Pphelp" className="midsecboxsec">
            <div className="midsecboxsecimg">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Portalimg.png"
                  className="img-fluid"
                  alt="Sacred Heart School Balia"
                />
              </LazyLoad>
            </div>
            <div className="midsecboxsecdesc">
              <p>Portal (Help?)</p>
            </div>
          </Link>
        </div>
        <div className="midsecbox2">
          <Link to="tel:09721014086" className="midsecboxdiv">
            <div className="midsecboxdivcircle">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/contactimg.png"
                  className="img-fluid"
                  alt="Sacred Heart School Balia"
                />
              </LazyLoad>  
            </div>
          </Link>
        </div>
        <div className="midsecbox1">
        <Link to="https://shsb.campussoft.net/" target="_blank"  className="midsecboxsec" rel="noreferrer">
            <div className="midsecboxsecimg">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Booklistimg.png"
                  className="img-fluid"
                  alt="Sacred Heart School Balia"
                />
              </LazyLoad>
            </div>
            <div className="midsecboxsecdesc">
              <p>Online Exam</p>
            </div>
          </Link>
          <Link to="/AdmissionProcess" className="midsecboxsec yel" rel="noreferrer">
            <div className="midsecboxsecimg">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/process.png"
                  className="img-fluid"
                  alt="Sacred Heart School Balia"
                />
              </LazyLoad>
            </div>
            <div className="midsecboxsecdesc">
              <p>Admission Process</p>
            </div>
          </Link>
          <Link to="/ErpSoftware" className="midsecboxsec" rel="noreferrer">
            <div className="midsecboxsecimg">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/erp.png"
                  className="img-fluid"
                  alt="Sacred Heart School Balia"
                />
              </LazyLoad>
            </div>
            <div className="midsecboxsecdesc">
              <p>ERP Software</p>
            </div>
          </Link>
        </div>
      </div>
    
 
      <div className="newnews">
        <div className="container-fluid">
             <div className="row">
                 <div className="col-lg-5 col-md-12">
                    <div className="newnewsgr">
                    <div className="section-title-two text-left">
                    <div className="section-title-two__sub-title-box">
                       <p className="section-title-two__sub-title">  
                      IMPORTANT INFORMATION
                       </p>
                    </div>
                    <h2 className="section-title section-title-two__title">Our Latest News</h2>
                 </div> 
                   <HomeNews/>
                    </div>
                <div className="why-choose-three__btn-box">
                     <Link to="/News" className="thm-btn"> View More </Link>
                 </div>
                 </div>
                 <div className="col-lg-6 col-md-12">
                 
                 </div>
             </div>
        </div>
   
   </div>
 
    <section className="about-sec">
<div className="container-fluid fullwdh">
      <div className="row">
         <div className="col-xl-6 col-lg-6 col-md-12">
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/aboutimg.png" className="img-fluid" alt="Sacred Heart School, Ballia"/></LazyLoad>
         </div>
         <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="about-sec__right">
               <div className="section-title text-left">
                  <div className="section-title__sub-title-box">
                     <p className="section-title__sub-title text-left"> About School  
                     </p>
                  </div>
                  <h2 className="section-title">Sacred Heart School, <span>Ballia</span></h2> 
               </div>
               <div className="aboutsecdesc">
               <p>Sacred Heart School (Affiliated to CISCE) serves students from Ballia city and the nearby villages. It promises to provide quality education that enables students to be inspired learners and responsible global citizens. With the help and support of its dedicated faculty the school will ensure the overall development of its students. We at Sacred Heart School believe each individual has intrinsic value and every person needs nurturing to thrive. Our aim to serve the society strengthens us. We are committed to develop a community service ethic and practice in all students. The school focuses on the pursuit of knowledge and skill. In particular we desire to attain the highest academic standards.</p>
               </div>
               
               <br />
              <div className="about-sec__btn-box d-block mx-auto">
              <Link to="/About" className="thm-btn about-sec__btn">Read More</Link> 
              
             </div>
              
            </div>
         </div>
      </div>
   </div>
</section>
<HomeMessage />
<div className="Schoolclubs">
  <div className="container-fluid">
    <div className="row">
    <div className="col-lg-12">
                  <div class="section-title text-center"> 
                        <div class="section-title__sub-title-box"> 
                        <p class="section-title__sub-title text-center"> SCHOOL CLUBS  </p> </div> 
                        <h2 class="section-title">OUR SCHOOL CLUBS</h2> </div> 
                  </div>
      <div className="col clubs-blk">
        <Link to="EnglishLiteraryClub">
        <div className="clubs_blk">
        <div className="clubs-img">
<LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/English-Club.gif" alt="Sacred Heart School, Ballia" /> </LazyLoad>
          </div>
          <p>English Literary Club</p>
        </div>
        </Link>
      </div>
      <div className="col clubs-blk">
      <Link to="GreenClub">
      <div className="clubs_blk">
        <div className="clubs-img">
          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Green-club.gif" alt="Sacred Heart School, Ballia" /> </LazyLoad>
          </div>
          <p>Green Club</p>
        </div>
        </Link>
      </div>
      <div className="col clubs-blk">
      <Link to="QuestClub">
      <div className="clubs_blk">
        <div className="clubs-img">
          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Quest-Club.gif" alt="Sacred Heart School, Ballia"  /> </LazyLoad>
          </div>
          <p>Quest Club</p>
        </div>
        </Link>
      </div>
      <div className="col clubs-blk">
      <Link to="MusicClub">
      <div className="clubs_blk">
        <div className="clubs-img">
          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Music-Club.gif"alt="Sacred Heart School, Ballia"  /> </LazyLoad>
          </div>
          <p>Music Club</p>
        </div>
        </Link>
      </div>
      <div className="col clubs-blk">
      <Link to="#">
      <div className="clubs_blk">
        <div className="clubs-img">
          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Sports-Club.gif" alt="Sacred Heart School, Ballia" /> </LazyLoad>
          </div>
          <p>Sports Club</p>
        </div>
        </Link>
      </div>
      <div className="col clubs-blk">
      <Link to="PerformingArtsClub">
       <div className="clubs_blk">
        <div className="clubs-img">
          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Performing-Arts-Club.gif" alt="Sacred Heart School, Ballia" /></LazyLoad> 
          </div>
          <p>Performing Arts Club</p>
        </div>
        </Link>
      </div>
      <div className="col clubs-blk">
      <Link to="RamanujanClub">
       <div className="clubs_blk">
          <div className="clubs-img">
          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Ramanujan-Club.gif" alt="Sacred Heart School, Ballia"  /> </LazyLoad>
          </div>
          <p>Ramanujan Club</p>
        </div>
        </Link>
      </div>
      <div className="col clubs-blk">
      <Link to="PiccasoClub">
       <div className="clubs_blk">
        <div className="clubs-img">
          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/Picasso-Club.gif" alt="Sacred Heart School, Ballia"  /> </LazyLoad>
          </div>
          <p>Piccaso Club</p>
        </div>
        </Link>
      </div>
    </div>
  </div>
 </div>

<div className="topper_bg padded-sec" id="Topper">
        <div className="container-fluid section-title">
          <div className='row'>
            <div className='col-lg-12 col-xl-8 col-md-12'>
            <div className="row">
            <div className='col-md-12'>
              <div className='topper-title'>
                <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/topper.png" className='img-fluid m-auto d-block' alt="Sacred Heart School, Ballia"  /></LazyLoad>
              </div>
            </div>
            <div className="col-lg-6">
              <div className='topper-block'>
              <div className='title'> 
                <h2><span>X</span> Toppers</h2>

                <div className='arrrow-btn'>
                  {/* <Link to="/">
                    <i class="bi bi-chevron-right"></i></Link>*/}
                </div> 
              </div>
              <HomeTopperX />
              </div>
              <div class="why-choose-three__btn-box">  <a class="thm-btn" href="/TopperX"> View More </a> </div>
             
            </div>    
                
            <div className="col-lg-6">
              
              <div className='topper-block'>
              <div className='title'> 
                <h2><span>XII</span>  Toppers</h2>
                <div className='arrrow-btn'>
                  {/* <Link to="/">
                    <i class="bi bi-chevron-right"></i>
                  </Link> */}
                </div>
              </div>
              <HomeTopperXII />
              </div>
              <div class="why-choose-three__btn-box">  <a class="thm-btn" href="/TopperXII"> View More </a> </div>
            </div>
          </div>
            </div>
            <div className='col-lg-12 col-xl-4 col-md-12'> 
            <div className='birthday-title'>
                <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/birthday.png" className='img-fluid m-auto d-block' alt="Sacred Heart School, Ballia"  /></LazyLoad>
              </div>
          
            <div className='topper-block'>
              <div className='title'>  
                <div className='arrrow-btn'>
                  {/* <Link to="/">
                    <i class="bi bi-chevron-right"></i>
                  </Link> */}
                </div>
              </div>
              <HomeBirthday />
              </div>
            </div>
          </div>
         
        </div>
      </div> 

      
      <section className="project-area fix">
        <div
          className="project-bg"
          style={{ backgroundImage: "url(https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/gallery-bg.png)" }}
        ></div>
        <div className="container custom-container-two">
          <div className="row justify-content-center">
            <div className="col-xl-6">
              <div className="section-title title-style-two text-center mb-40 tg-heading-subheading animation-style2">
                <center>
                  <div className="section-title">
                    <div className="section-title__sub-title-box">
                      <p className="section-title__sub-title">
                      <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/gallery-icon.png" alt="Sacred Heart School, Ballia"  /></LazyLoad>
                      </p>
                    </div>
                    <h2 className="section-title"> Photo Gallery</h2>
                  </div>
                </center>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">

              <HomeGallery />
            </div>
          </div>
          <center>
            <div className="about-sec__btn-box">
              <Link to="/Gallery" className="thm-btn about-sec__btn">
                View Gallery 
              </Link>
            </div>
          </center>
        </div>
      </section>
       <Footer/>
    </>
  );
};

export default Home;
